export enum ConfirmDialogType {
  sendEmail = 'sendEmail',
  unarchive = 'unarchive',
  changeVisibility = 'changeVisibility',
  plainDelete = 'plainDelete',
  deleteWithNestedEntities = 'deleteWithNestedEntities',
  deleteWithAssignedEntitiesCancelling = 'deleteWithAssignedEntitiesCancelling',
  deleteContactWithAllAssignmentsRemoving = 'deleteContactWithAllAssignmentsRemoving',
  archiveContactWithAllAssignmentsRemoving = 'archiveContactWithAllAssignmentsRemoving',
  removeContactAssignmentFromLot = 'removeContactAssignmentFromLot'
}

export interface ConfigOverride {
  type: ConfirmDialogType;
  question?: string;
  text?: string;
  cancelLabel?: string;
  confirmLabel?: string;
  confirmBtnClassName?: string;
}
